<div class="stock-price-threshold-container no-select">

  <div class="widget-div">

    @if (canStockThresholdBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canStockThresholdBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canStockThresholdBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Price Thresholds</div>
          <app-display-icon
            [tooltip]="tooltips.priceThreshold"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formStockThreshold">

            @if (formStockThreshold?.controls['pct']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="pct">Maximum Increase in Price (%)</label>
                  <input
                    [class.invalid]="formStockThreshold?.controls['pct']?.errors"
                    [formControlName]="'pct'"
                    [placeholder]="'Enter percentage (0-100)'"
                    id="pct"
                    type="number"
                    min="0"
                    max="100"/>
                </div>
              </div>
            }

            @if (formStockThreshold?.controls['negPct']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="negPct">Maximum Decrease in Price (%)</label>
                  <input
                    [class.invalid]="formStockThreshold?.controls['negPct']?.errors"
                    [formControlName]="'negPct'"
                    [placeholder]="'Enter percentage (0-100)'"
                    id="negPct"
                    type="number"
                    min="0"
                    max="100"/>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasStockThresholdBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canStockThresholdBeEdited === false"
              (click)="onRevertForm('stockThreshold')">
              <app-display-icon
                [colour]="canStockThresholdBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canStockThresholdBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isStockThresholdSubmitDisabled"
              (click)="onSubmitForm('stockThreshold')">
              <app-display-icon
                [colour]="isStockThresholdSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    @if (hasStockThresholdErrors?.length > 0) {
      @for (field of hasStockThresholdErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
